import { ContextsService } from '@inference.engine/api-client/web';
import { inferenceHttp } from '@/lib/api/http-client';

type GetManyOptions = NonNullable<Parameters<typeof ContextsService.getContexts>[0]>;
type GetManyQueryParams = NonNullable<GetManyOptions['query']>;

export type GetChatsParams = Omit<GetManyQueryParams, 'sortOrder' | 'workspaceId'> & {
  sortOrder?: 'asc' | 'desc';
  workspaceId: string;
};

export const getChatSessions = async (params: GetChatsParams) => {
  const response = await ContextsService.getContexts({
    client: inferenceHttp,
    query: {
      ...params,
      sortOrder: params.sortOrder?.toUpperCase(),
    },
  });

  if (!response.data) {
    throw new Error('No data returned');
  }

  return response.data;
};

export const updateChatSession = async (contextId: string, updates: { title?: string }) => {
  const response = await ContextsService.updateMetadata({
    client: inferenceHttp,
    path: { contextId },
    body: {
      title: updates.title,
    },
  });

  if (!response.data) {
    throw new Error('No data returned');
  }

  return response.data;
};
